export default "__VITE_ASSET__Bwndzvaw__"